import { Button, ButtonProps } from '@chakra-ui/react';
import IconListCheck from 'assets/icons/icon-list-check.svg?react';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { Link, LinkProps } from 'react-router-dom';
import WrapperDialog from './WrapperDialog';

type Props = ButtonProps & LinkProps & {
  title?: string
};

export default function ButtonBackToList({ title = 'Voltar para listagem', ...props }: Props) {
  return (
    <WrapperDialog {...wrapperDialogDefaultProps}>
      <Button 
        leftIcon={<IconListCheck />}
        as={Link}
        {...props}
      >
        {title}
      </Button>
    </WrapperDialog>
  )
}
